import React, { useEffect, useMemo, useRef, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import {
  Autocomplete,
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  LinearProgress,
  Paper,
  Stack,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PhotoLibraryIcon from "@mui/icons-material/PhotoLibrary";
import PrintIcon from "@mui/icons-material/Print";
import SaveIcon from "@mui/icons-material/Save";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import PersonIcon from "@mui/icons-material/Person";
import { addDoc, collection, doc, getDoc, getDocs, orderBy, query, updateDoc, where } from "firebase/firestore";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { useHistory, useParams } from "react-router-dom";
import Navbar from "../Components/Navbar/navbar";
import HistoricoCadastro from "../Components/HistoricoCadastro/HistoricoCadastro";
import { auth, db, storage } from "../Config/firebase";
import { gerarSequencial, obterMaiorSequencial } from "../Utils/sequencial";
import "./CadastroCimentoPega.css";
import "../CadastroExtracoes/DetalhesExtracao.css";
import RelatorioInicioPegaPrint from "./RelatorioInicioPegaPrint";
import { consultaTenantAtual , aplicarTenantAtual} from "../Utils/tenant";
import LogoRelatorio from "../Components/LogoRelatorio/LogoRelatorio";
import useNomeArquivoPdf from "../Utils/useNomeArquivoPdf";
import { atualizarDocumentoComMesclagem } from "../Utils/concorrenciaFirestore";

const tentativasConsistencia = Array.from({ length: 10 }, (_, index) => ({
  tentativa: index + 1,
  massaCimento: "500",
  aditivo1Quantidade: "",
  aditivo1Percentual: "",
  aditivo2Quantidade: "",
  aditivo2Percentual: "",
  aguaQuantidade: "",
  aguaPercentual: "",
  penetracao: "",
  situacao: "",
}));

const leiturasInicio = Array.from({ length: 15 }, (_, index) => ({
  leitura: index + 1,
  hora: "",
  tempoDecorrido: "",
  penetracao: "",
  observacoes: "",
}));

const leiturasFim = Array.from({ length: 10 }, (_, index) => ({
  leitura: index + 1,
  hora: "",
  tempoDecorrido: "",
  penetracao: "",
  observacoes: "",
}));

const dosagemVazia = [
  { material: "CIMENTO", descricao: "", massa: "", percentual: "" },
  { material: "ADITIVO 1", descricao: "", massa: "", percentual: "" },
  { material: "ADITIVO 2", descricao: "", massa: "", percentual: "" },
  { material: "ADICAO", descricao: "", massa: "", percentual: "" },
  { material: "AGUA", descricao: "", massa: "", percentual: "" },
];

const estadoInicial = {
  codigo: "",
  cliente: "",
  obra: "",
  obraId: "",
  endereco: "",
  materialId: "",
  materialCodigo: "",
  cimento: "",
  aditivo1Id: "",
  aditivo1: "",
  aditivo1Quantidade: "",
  aditivo1Percentual: "",
  aditivo2Id: "",
  aditivo2: "",
  aditivo2Quantidade: "",
  aditivo2Percentual: "",
  adicaoId: "",
  adicao: "",
  adicaoQuantidade: "",
  adicaoPercentual: "",
  data: "",
  operador: "",
  temperatura: "",
  umidade: "",
  penetracaoObtida: "",
  penetracaoConsistenciaObtida: "",
  penetracaoInicioObtida: "",
  penetracaoFimObtida: "",
  horarioInicioMistura: "",
  observacoes: "",
  observacaoResultado: "",
  consistencia: tentativasConsistencia,
  dosagem: dosagemVazia,
  leiturasInicio,
  leiturasFim,
  resultadoInicio: {
    hora: "",
    tempoHoraMin: "",
  },
  resultadoFim: {
    hora: "",
    tempoHoraMin: "",
  },
};

function clonarEstadoInicial() {
  return {
    ...estadoInicial,
    consistencia: tentativasConsistencia.map((linha) => ({ ...linha })),
    dosagem: dosagemVazia.map((linha) => ({ ...linha })),
    leiturasInicio: leiturasInicio.map((linha) => ({ ...linha })),
    leiturasFim: leiturasFim.map((linha) => ({ ...linha })),
    resultadoInicio: { ...estadoInicial.resultadoInicio },
    resultadoFim: { ...estadoInicial.resultadoFim },
  };
}

function normalizarEnsaio(item = {}) {
  const base = clonarEstadoInicial();
  const ensaio = {
    ...base,
    ...item,
    aditivo1Quantidade: item.aditivo1Quantidade || "",
    aditivo1Percentual: item.aditivo1Percentual || "",
    aditivo2Quantidade: item.aditivo2Quantidade || "",
    aditivo2Percentual: item.aditivo2Percentual || "",
    adicaoId: item.adicaoId || "",
    adicao: item.adicao || "",
    adicaoQuantidade: item.adicaoQuantidade || "",
    adicaoPercentual: item.adicaoPercentual || "",
    penetracaoConsistenciaObtida: item.penetracaoConsistenciaObtida || item.penetracaoObtida || "",
    penetracaoInicioObtida: item.penetracaoInicioObtida || "",
    penetracaoFimObtida: item.penetracaoFimObtida || "",
    consistencia: base.consistencia.map((linha, index) => ({
      ...linha,
      ...(item.consistencia?.[index] || {}),
    })),
    dosagem: base.dosagem.map((linha, index) => ({
      ...linha,
      ...(item.dosagem?.[index] || {}),
    })),
    leiturasInicio: base.leiturasInicio.map((linha, index) => ({
      ...linha,
      ...(item.leiturasInicio?.[index] || {}),
    })),
    leiturasFim: base.leiturasFim.map((linha, index) => ({
      ...linha,
      ...(item.leiturasFim?.[index] || {}),
    })),
    resultadoInicio: { ...base.resultadoInicio, ...(item.resultadoInicio || {}) },
    resultadoFim: { ...base.resultadoFim, ...(item.resultadoFim || {}) },
  };

  return recalcularEnsaio(sincronizarDosagemComConsistencia(ensaio));
}

function numeroBR(valor) {
  const numero = Number(String(valor || "").replace(",", "."));
  return Number.isFinite(numero) ? numero : null;
}

function formatarNumero(valor, casas = 2) {
  const numero = Number(valor);
  if (!Number.isFinite(numero)) return "";
  return numero.toFixed(casas).replace(".", ",").replace(/,?0+$/, "");
}

function calcularQuantidadePorPercentual(percentual, massaBase = 500) {
  const numero = numeroBR(percentual);
  if (numero === null) return "";
  return formatarNumero((massaBase * numero) / 100, 3);
}

function ultimaLinhaComPenetracao(linhas = []) {
  return [...linhas].reverse().find((linha) => String(linha?.penetracao || "").trim() !== "") || null;
}

function minutosHora(hora) {
  const texto = String(hora || "").trim();
  const match = texto.match(/^(\d{1,2}):(\d{2})$/);
  if (!match) return null;
  const horas = Number(match[1]);
  const minutos = Number(match[2]);
  if (horas > 23 || minutos > 59) return null;
  return horas * 60 + minutos;
}

function calcularTempoHoraMin(inicio, fim) {
  const minutoInicio = minutosHora(inicio);
  const minutoFim = minutosHora(fim);
  if (minutoInicio === null || minutoFim === null) return "";
  let diferenca = minutoFim - minutoInicio;
  if (diferenca < 0) diferenca += 24 * 60;
  const horas = Math.floor(diferenca / 60);
  const minutos = diferenca % 60;
  return `${horas}h${String(minutos).padStart(2, "0")}min`;
}

function formatarTempoComUnidade(tempo) {
  const texto = String(tempo || "").trim();
  if (!texto) return "-";

  const comDoisPontos = texto.match(/^(\d+):(\d{1,2})$/);
  if (comDoisPontos) {
    return `${Number(comDoisPontos[1])}h${comDoisPontos[2].padStart(2, "0")}min`;
  }

  const comUnidade = texto.match(/^(\d+)h(\d{1,2})(?:min)?$/i);
  if (comUnidade) {
    return `${Number(comUnidade[1])}h${comUnidade[2].padStart(2, "0")}min`;
  }

  return texto;
}

function formatarMilimetros(valorCampo) {
  const texto = String(valorCampo || "").trim();
  if (!texto) return "-";
  if (/mm$/i.test(texto)) return texto.replace(/\s*mm$/i, " mm");
  return `${texto} mm`;
}

function formatarGramas(valorCampo) {
  const texto = String(valorCampo || "").trim();
  if (!texto || texto === "-") return "-";
  if (/g$/i.test(texto)) return texto.replace(/\s*g$/i, " g");
  return `${texto} g`;
}

function formatarPercentual(valorCampo) {
  const texto = String(valorCampo || "").trim();
  if (!texto || texto === "-") return "-";
  if (/%$/.test(texto)) return texto.replace(/\s*%$/, "%");
  return `${texto}%`;
}

function recalcularEnsaio(dados) {
  const ultimaConsistencia = ultimaLinhaComPenetracao(dados.consistencia || []);
  const ultimaInicio = ultimaLinhaComPenetracao(dados.leiturasInicio || []);
  const ultimaFim = ultimaLinhaComPenetracao(dados.leiturasFim || []);

  return {
    ...dados,
    aditivo1Quantidade: calcularQuantidadePorPercentual(dados.aditivo1Percentual),
    aditivo2Quantidade: calcularQuantidadePorPercentual(dados.aditivo2Percentual),
    adicaoQuantidade: calcularQuantidadePorPercentual(dados.adicaoPercentual),
    penetracaoConsistenciaObtida: ultimaConsistencia?.penetracao || "",
    penetracaoInicioObtida: ultimaInicio?.penetracao || "",
    penetracaoFimObtida: ultimaFim?.penetracao || "",
    penetracaoObtida: ultimaInicio?.penetracao || ultimaConsistencia?.penetracao || "",
    resultadoInicio: {
      hora: ultimaInicio?.hora || "",
      tempoHoraMin: calcularTempoHoraMin(dados.horarioInicioMistura, ultimaInicio?.hora),
    },
    resultadoFim: {
      hora: ultimaFim?.hora || "",
      tempoHoraMin: calcularTempoHoraMin(dados.horarioInicioMistura, ultimaFim?.hora),
    },
  };
}

function sincronizarDosagemComConsistencia(dados) {
  const linhasPreenchidas = (dados.consistencia || []).filter((linha) =>
    [
      linha.aguaQuantidade,
      linha.aguaPercentual,
      linha.penetracao,
      linha.situacao,
    ].some((valor) => String(valor || "").trim() !== "")
  );
  const linhaFinal = linhasPreenchidas.at(-1) || dados.consistencia?.[0] || {};
  const aditivo1Quantidade = calcularQuantidadePorPercentual(dados.aditivo1Percentual);
  const aditivo2Quantidade = calcularQuantidadePorPercentual(dados.aditivo2Percentual);
  const adicaoQuantidade = calcularQuantidadePorPercentual(dados.adicaoPercentual);

  return {
    ...dados,
    aditivo1Quantidade,
    aditivo2Quantidade,
    adicaoQuantidade,
    dosagem: [
      {
        material: "CIMENTO",
        descricao: dados.cimento || "",
        massa: "500",
        percentual: "100",
      },
      {
        material: "ADITIVO 1",
        descricao: dados.aditivo1 || "",
        massa: aditivo1Quantidade,
        percentual: dados.aditivo1Percentual || "",
      },
      {
        material: "ADITIVO 2",
        descricao: dados.aditivo2 || "",
        massa: aditivo2Quantidade,
        percentual: dados.aditivo2Percentual || "",
      },
      {
        material: "ADICAO",
        descricao: dados.adicao || "",
        massa: adicaoQuantidade,
        percentual: dados.adicaoPercentual || "",
      },
      {
        material: "AGUA",
        descricao: "",
        massa: linhaFinal.aguaQuantidade || "",
        percentual: linhaFinal.aguaPercentual || "",
      },
    ],
  };
}

function normalizarTexto(valor) {
  return String(valor || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
}

function formatarDataBR(dataISO) {
  if (!dataISO) return "-";
  const [ano, mes, dia] = String(dataISO).split("-");
  if (!ano || !mes || !dia) return dataISO;
  return `${dia}/${mes}/${ano}`;
}

function formatarMaterialComPercentual(material, percentual) {
  const nome = String(material || "").trim() || "-";
  const valorPercentual = String(percentual || "").trim();
  return valorPercentual ? `${nome} (${valorPercentual}%)` : nome;
}

function ehMaterialCimento(material) {
  if (material?.IsCimento === true) return true;
  const texto = normalizarTexto(
    `${material?.Descricao || ""} ${material?.tipoMaterial || ""} ${material?.Ensaios || ""}`
  );
  return texto.includes("cimento");
}

function ehMaterialAditivo(material) {
  if (material?.IsAditivo === true) return true;
  const texto = normalizarTexto(
    `${material?.Descricao || ""} ${material?.tipoMaterial || ""} ${material?.Ensaios || ""}`
  );
  return texto.includes("aditivo");
}

function ehMaterialAdicao(material) {
  return material?.IsAdicao === true;
}

function calcularProximoCodigo(lista) {
  const numeros = lista
    .map((item) => Number(String(item.codigo || "").match(/\d+/)?.[0]))
    .filter(Number.isFinite);
  const proximo = numeros.length ? Math.max(...numeros) + 1 : lista.length + 1;
  return String(proximo).padStart(3, "0");
}

function rotuloMaterial(material) {
  if (!material) return "";
  return `${material.codigo || ""} - ${material.Descricao || ""} - ${material.Cliente || ""}`;
}

function rotuloObra(obra) {
  if (!obra) return "";
  return `${obra.nome || ""}${obra.clienteNome ? ` - ${obra.clienteNome}` : ""}`;
}

function fotoRelatorioValida(foto) {
  const url = String(foto?.url || foto?.previewUrl || "").trim();
  if (!url) return false;
  return !/\/Images\/logo/i.test(url);
}

function criarFotoRelatorioVazia(index) {
  return {
    id: `foto-vazia-${index + 1}-${Date.now()}`,
    legenda: `FOTO ${String(index + 1).padStart(2, "0")}`,
    url: "",
  };
}

function garantirMinimoFotosRelatorio(fotos) {
  const lista = [...fotos];
  while (lista.length < 2) {
    lista.push(criarFotoRelatorioVazia(lista.length));
  }
  return lista.map((foto, index) => ({
    ...foto,
    legenda: foto.legenda || `FOTO ${String(index + 1).padStart(2, "0")}`,
  }));
}

function CadastroCimentoPega() {
  const { ensaioId } = useParams();
  const history = useHistory();
  const [ensaios, setEnsaios] = useState([]);
  const [materiais, setMateriais] = useState([]);
  const [obras, setObras] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtro, setFiltro] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [aba, setAba] = useState(0);
  const [modoEdicao, setModoEdicao] = useState(false);
  const [itemEditando, setItemEditando] = useState(null);
  const [form, setForm] = useState(clonarEstadoInicial);
  const [modoPrint, setModoPrint] = useState(false);
  const [itemPrint, setItemPrint] = useState(null);
  const [autoPrint, setAutoPrint] = useState(false);
  const [salvando, setSalvando] = useState(false);
  const [mensagem, setMensagem] = useState("");
  const [estadoOriginalEdicao, setEstadoOriginalEdicao] = useState("");
  const [openFotos, setOpenFotos] = useState(false);
  const [fotosDraft, setFotosDraft] = useState([]);
  const [salvandoFotos, setSalvandoFotos] = useState(false);
  const [progressoFotos, setProgressoFotos] = useState(0);
  const [openConfirmarCancelamento, setOpenConfirmarCancelamento] = useState(false);
  const [navegacaoPendente, setNavegacaoPendente] = useState(null);
  const [usuario, setUsuario] = useState(null);
  const [obrasUsuario, setObrasUsuario] = useState([]);
  const desbloquearNavegacaoRef = useRef(null);
  const ensaioOriginalRef = useRef(null);
  const clienteLogado = usuario?.tipo === "cliente";

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setUsuario(null);
        setObrasUsuario([]);
        return;
      }

      const snap = await getDoc(doc(db, "users", user.uid));
      if (snap.exists()) {
        const dados = snap.data();
        setUsuario({
          ...dados,
          tipo: String(dados.tipo || dados.tipoUsuario || "").toLowerCase(),
        });
        setObrasUsuario(dados.obras || []);
      } else {
        setUsuario({
          tipo: String(localStorage.getItem("tipoUsuario") || "").toLowerCase(),
        });
        setObrasUsuario([]);
      }
    });

    return () => unsub();
  }, []);

  useEffect(() => {
    if (!usuario) return;

    if (ensaioId) {
      carregarEnsaioDetalhes();
    } else {
      carregarEnsaios();
    }
  }, [ensaioId, usuario, obrasUsuario]);

  useEffect(() => {
    if (!usuario || clienteLogado) return;

    carregarMateriais();
    carregarObras();
  }, [usuario, clienteLogado]);

  async function carregarEnsaioDetalhes() {
    const snap = await getDoc(doc(db, "tblCimentoConsistenciaPega", ensaioId));
    if (!snap.exists()) return;
    const ensaio = normalizarEnsaio({ id: snap.id, ...snap.data() });
    setForm(ensaio);
    ensaioOriginalRef.current = ensaio;
    setEstadoOriginalEdicao(JSON.stringify(ensaio));
    setMensagem("");
    setOpenConfirmarCancelamento(false);
  }

  async function carregarEnsaios() {
    setLoading(true);
    try {
      if (clienteLogado && obrasUsuario.length === 0) {
        setEnsaios([]);
        return;
      }

      const q = clienteLogado
        ? query(
            collection(db, "tblCimentoConsistenciaPega"),
            where("obraId", "in", obrasUsuario)
          )
        : query(collection(db, "tblCimentoConsistenciaPega"), orderBy("criadoEm", "desc"));

      const snap = await getDocs(consultaTenantAtual(q));
      const lista = snap.docs.map((documento) => ({ id: documento.id, ...documento.data() }));
      setEnsaios(
        clienteLogado
          ? lista.filter((item) => obrasUsuario.includes(item.obraId))
              .filter((item) => item.ocultoCliente !== true)
          : lista
      );
    } finally {
      setLoading(false);
    }
  }

  async function carregarMateriais() {
    const q = query(collection(db, "tblListaMateriaisCadastrados"), orderBy("codigo", "desc"));
    const snap = await getDocs(consultaTenantAtual(q));
    setMateriais(snap.docs.map((documento) => ({ id: documento.id, ...documento.data() })));
  }

  async function carregarObras() {
    const snap = await getDocs(consultaTenantAtual(collection(db, "obras")));
    setObras(snap.docs.map((documento) => ({ id: documento.id, ...documento.data() })));
  }

  const materiaisCimento = useMemo(() => materiais.filter(ehMaterialCimento), [materiais]);
  const materiaisAditivo = useMemo(() => materiais.filter(ehMaterialAditivo), [materiais]);
  const materiaisAdicao = useMemo(() => materiais.filter(ehMaterialAdicao), [materiais]);
  const adicaoSelecionada = useMemo(() => {
    const porId = materiaisAdicao.find((material) => material.id === form.adicaoId);
    if (porId) return porId;

    const adicaoAtual = normalizarTexto(form.adicao);
    return adicaoAtual
      ? materiaisAdicao.find((material) => normalizarTexto(material.Descricao) === adicaoAtual) || null
      : null;
  }, [form.adicao, form.adicaoId, materiaisAdicao]);

  function abrirNovoCadastro() {
    if (clienteLogado) return;

    setModoEdicao(false);
    setItemEditando(null);
    setAba(0);
    setForm({
      ...clonarEstadoInicial(),
      data: new Date().toISOString().slice(0, 10),
    });
    setOpenDialog(true);
  }

  function selecionarCimento(material) {
    setForm((atual) => {
      const proximaDosagem = atual.dosagem.map((linha) =>
        linha.material === "CIMENTO"
          ? { ...linha, descricao: material?.Descricao || "", massa: linha.massa || "500" }
          : linha
      );

      return recalcularEnsaio(sincronizarDosagemComConsistencia({
        ...atual,
        materialId: material?.id || "",
        materialCodigo: material?.codigo || "",
        cimento: material?.Descricao || "",
        cliente: atual.cliente || material?.Cliente || "",
        dosagem: proximaDosagem,
      }));
    });
  }

  function selecionarObra(obra) {
    setForm((atual) => recalcularEnsaio(sincronizarDosagemComConsistencia({
      ...atual,
      obraId: obra?.id || "",
      obra: obra?.nome || "",
      cliente: obra?.clienteEtiqueta || obra?.clienteNome || atual.cliente || "",
      endereco: obra?.endereco || "",
    })));
  }

  function selecionarAditivo(campo, material) {
    const materialLabel = campo === "aditivo1" ? "ADITIVO 1" : "ADITIVO 2";
    const proximaDosagem = form.dosagem.map((linha) =>
      linha.material === materialLabel ? { ...linha, descricao: material?.Descricao || "" } : linha
    );

    setForm(recalcularEnsaio(sincronizarDosagemComConsistencia({
      ...form,
      [`${campo}Id`]: material?.id || "",
      [campo]: material?.Descricao || "",
      dosagem: proximaDosagem,
    })));
  }

  function selecionarAdicao(material) {
    setForm((atual) => recalcularEnsaio(sincronizarDosagemComConsistencia({
      ...atual,
      adicaoId: material?.id || "",
      adicao: material?.Descricao || "",
    })));
  }

  function atualizarCampo(campo, valor) {
    setForm((atual) => {
      const proximo = { ...atual, [campo]: valor };
      return recalcularEnsaio(sincronizarDosagemComConsistencia(proximo));
    });
  }

  function atualizarLinha(lista, index, campo, valor) {
    setForm((atual) => {
      const proximo = {
        ...atual,
        [lista]: atual[lista].map((linha, linhaIndex) =>
          linhaIndex === index ? { ...linha, [campo]: valor } : linha
        ),
      };
      return recalcularEnsaio(sincronizarDosagemComConsistencia(proximo));
    });
  }

  function adicionarTentativaConsistencia() {
    setForm((atual) => ({
      ...atual,
      consistencia: [
        ...(atual.consistencia || []),
        {
          tentativa: (atual.consistencia || []).length + 1,
          massaCimento: "500",
          aditivo1Quantidade: "",
          aditivo1Percentual: "",
          aditivo2Quantidade: "",
          aditivo2Percentual: "",
          aguaQuantidade: "",
          aguaPercentual: "",
          penetracao: "",
          situacao: "",
        },
      ],
    }));
  }

  function atualizarResultado(tipo, campo, valor) {
    const chave = tipo === "inicio" ? "resultadoInicio" : "resultadoFim";
    setForm((atual) => ({
      ...atual,
      [chave]: { ...atual[chave], [campo]: valor },
    }));
  }

  function editarEnsaio(item) {
    if (clienteLogado) return;

    setModoEdicao(true);
    setItemEditando(item);
    setForm(normalizarEnsaio(item));
    setOpenDialog(true);
  }

  async function salvarEnsaio() {
    if (clienteLogado) return;

    if (!form.materialId || !form.cimento) {
      alert("Selecione o material/cimento antes de salvar.");
      return;
    }

    setSalvando(true);
    setMensagem("");

    const dadosSemId = { ...recalcularEnsaio(sincronizarDosagemComConsistencia(form)) };
    delete dadosSemId.id;
    const codigo = ensaioId || (modoEdicao && itemEditando?.id)
      ? dadosSemId.codigo
      : dadosSemId.codigo || (await gerarSequencial({
          chave: "cimento_pega",
          formato: { padding: 3 },
          valorMinimo: obterMaiorSequencial(ensaios),
        })).codigo;
    const dados = {
      ...dadosSemId,
      codigo,
      atualizadoEm: new Date(),
    };

    try {
      if (ensaioId) {
        const dadosSalvos = await atualizarDocumentoComMesclagem({
          db,
          referencia: doc(db, "tblCimentoConsistenciaPega", ensaioId),
          original: ensaioOriginalRef.current,
          atual: { ...form, ...dados },
          preparar: (dadosMesclados) => {
            const { id: _id, ...dadosPreparados } = dadosMesclados;
            return recalcularEnsaio(sincronizarDosagemComConsistencia(dadosPreparados));
          },
          metadados: { atualizadoEm: dados.atualizadoEm },
        });
        const atualizado = normalizarEnsaio({ ...dadosSalvos, id: ensaioId });
        setForm(atualizado);
        ensaioOriginalRef.current = atualizado;
        setEstadoOriginalEdicao(JSON.stringify(atualizado));
        setMensagem("Salvo com sucesso!");
      } else if (modoEdicao && itemEditando?.id) {
        await atualizarDocumentoComMesclagem({
          db,
          referencia: doc(db, "tblCimentoConsistenciaPega", itemEditando.id),
          original: itemEditando,
          atual: { ...itemEditando, ...dados },
          preparar: (dadosMesclados) => {
            const { id: _id, ...dadosPreparados } = dadosMesclados;
            return recalcularEnsaio(sincronizarDosagemComConsistencia(dadosPreparados));
          },
          metadados: { atualizadoEm: dados.atualizadoEm },
        });
        setOpenDialog(false);
        setModoEdicao(false);
        setItemEditando(null);
        await carregarEnsaios();
      } else {
        const novoDocumento = await addDoc(collection(db, "tblCimentoConsistenciaPega"), aplicarTenantAtual({
          ...dados,
          ocultoCliente: true,
          criadoEm: new Date(),
        }));
        setEnsaios((atuais) => [
          { ...dados, id: novoDocumento.id, ocultoCliente: true, criadoEm: new Date() },
          ...atuais,
        ]);
        setOpenDialog(false);
        history.push(`/app/cimento-consistencia-pega/${novoDocumento.id}`);
      }
    } catch (error) {
      console.error(error);
      setMensagem("Erro ao salvar o ensaio.");
    } finally {
      setSalvando(false);
    }
  }

  function abrirRelatorio(item, imprimir = false) {
    setItemPrint(normalizarEnsaio(item));
    setAutoPrint(imprimir);
    setModoPrint(true);
  }

  async function alternarVisibilidadeCliente(item) {
    if (clienteLogado || !item?.id) return;

    const ocultar = item.ocultoCliente !== true;
    await updateDoc(doc(db, "tblCimentoConsistenciaPega", item.id), {
      ocultoCliente: ocultar,
      atualizadoEm: new Date(),
    });

    setEnsaios((atuais) =>
      atuais.map((ensaio) =>
        ensaio.id === item.id
          ? { ...ensaio, ocultoCliente: ocultar, atualizadoEm: new Date() }
          : ensaio
      )
    );
  }

  async function voltarParaLista() {
    await carregarEnsaios();
    history.push("/app/cimento-consistencia-pega");
  }

  function abrirFotos() {
    const fotosSalvas = (form.relatorioFotografico || [])
      .filter(fotoRelatorioValida)
      .map((foto, index) => ({
        ...foto,
        id: foto.id || `foto-${index + 1}`,
        legenda: foto.legenda || `FOTO ${String(index + 1).padStart(2, "0")}`,
      }));

    setFotosDraft(garantirMinimoFotosRelatorio(fotosSalvas));
    setOpenFotos(true);
  }

  function adicionarFoto() {
    setFotosDraft((fotos) => [...fotos, {
      id: `foto-${Date.now()}`,
      legenda: `FOTO ${String(fotos.length + 1).padStart(2, "0")}`,
      url: "",
    }]);
  }

  function selecionarFoto(index, arquivo) {
    if (!arquivo) return;
    setFotosDraft((fotos) => fotos.map((foto, itemIndex) =>
      itemIndex === index ? { ...foto, arquivo, previewUrl: URL.createObjectURL(arquivo) } : foto
    ));
  }

  function removerFoto(index) {
    setFotosDraft((fotos) => {
      if (fotos.length <= 2) {
        return garantirMinimoFotosRelatorio(
          fotos.map((foto, itemIndex) =>
            itemIndex === index
              ? criarFotoRelatorioVazia(itemIndex)
              : foto
          )
        );
      }

      return garantirMinimoFotosRelatorio(fotos.filter((_, itemIndex) => itemIndex !== index));
    });
  }

  async function salvarFotos() {
    if (!ensaioId) return;
    setSalvandoFotos(true);
    setProgressoFotos(0);
    try {
      const fotosSalvas = [];
      const totalUploads = fotosDraft.filter((foto) => foto.arquivo).length;
      let uploadsConcluidos = 0;
      for (let index = 0; index < fotosDraft.length; index += 1) {
        const foto = fotosDraft[index];
        let url = foto.url || "";
        let path = foto.path || "";
        if (foto.arquivo) {
          const extensao = foto.arquivo.type === "image/png"
            ? "png"
            : foto.arquivo.type === "image/webp"
              ? "webp"
              : "jpg";

          path = `cimento-pega/${ensaioId}/relatorio-fotografico/foto-${index + 1}-${Date.now()}.${extensao}`;
          await uploadBytes(ref(storage, path), foto.arquivo, { contentType: foto.arquivo.type || "image/jpeg" });
          url = await getDownloadURL(ref(storage, path));
          uploadsConcluidos += 1;
          setProgressoFotos(totalUploads ? Math.round((uploadsConcluidos / totalUploads) * 100) : 100);
        }
        if (url) fotosSalvas.push({
          id: foto.id || `foto-${index + 1}`,
          legenda: foto.legenda || `FOTO ${String(index + 1).padStart(2, "0")}`,
          url,
          path,
        });
      }
      await updateDoc(doc(db, "tblCimentoConsistenciaPega", ensaioId), {
        relatorioFotografico: fotosSalvas,
        atualizadoEm: new Date(),
      });
      const atualizado = { ...form, relatorioFotografico: fotosSalvas };
      setForm(atualizado);
      ensaioOriginalRef.current = atualizado;
      setEstadoOriginalEdicao(JSON.stringify(atualizado));
      setOpenFotos(false);
      setMensagem("Relatório fotográfico salvo com sucesso!");
    } catch (error) {
      console.error(error);
      setMensagem("Erro ao salvar o relatório fotográfico.");
    } finally {
      setSalvandoFotos(false);
      setProgressoFotos(0);
    }
  }

  const listaFiltrada = useMemo(() => {
    const termo = normalizarTexto(filtro);
    const base = termo
      ? ensaios.filter((item) =>
          [item.codigo, item.cliente, item.obra, item.cimento, item.aditivo1, item.aditivo2, item.adicao, item.operador].some((valor) =>
            normalizarTexto(valor).includes(termo)
          )
        )
      : ensaios;

    return [...base].sort((a, b) => {
      const codigoA = Number(String(a.codigo || "").match(/\d+/)?.[0] || 0);
      const codigoB = Number(String(b.codigo || "").match(/\d+/)?.[0] || 0);

      if (codigoA !== codigoB) return codigoB - codigoA;
      return String(b.codigo || "").localeCompare(String(a.codigo || ""));
    });
  }, [ensaios, filtro]);

  const temAlteracoes = Boolean(
    ensaioId &&
      estadoOriginalEdicao &&
      JSON.stringify(form) !== estadoOriginalEdicao
  );

  useEffect(() => {
    function confirmarSaida(event) {
      if (!temAlteracoes) return;

      event.preventDefault();
      event.returnValue = "";
    }

    window.addEventListener("beforeunload", confirmarSaida);
    return () => window.removeEventListener("beforeunload", confirmarSaida);
  }, [temAlteracoes]);

  useEffect(() => {
    if (!temAlteracoes) return undefined;

    desbloquearNavegacaoRef.current = history.block((locationBloqueada) => {
      setNavegacaoPendente(locationBloqueada);
      setOpenConfirmarCancelamento(true);
      return false;
    });

    return () => {
      desbloquearNavegacaoRef.current?.();
      desbloquearNavegacaoRef.current = null;
    };
  }, [history, temAlteracoes]);

  function solicitarCancelarAlteracoes() {
    setNavegacaoPendente(null);
    setOpenConfirmarCancelamento(true);
  }

  async function confirmarCancelarAlteracoes() {
    setOpenConfirmarCancelamento(false);
    await carregarEnsaioDetalhes();

    if (navegacaoPendente) {
      const destino = `${navegacaoPendente.pathname}${navegacaoPendente.search || ""}${navegacaoPendente.hash || ""}`;
      desbloquearNavegacaoRef.current?.();
      desbloquearNavegacaoRef.current = null;
      setNavegacaoPendente(null);
      history.push(destino);
    }
  }

  const camposBasicos = (
    <Stack spacing={2} mt={1}>
      <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
        <TextField label="Código" value={form.codigo} onChange={(event) => atualizarCampo("codigo", event.target.value)} sx={{ width: { md: 160 } }} />
        <Autocomplete
          options={materiaisCimento}
          getOptionLabel={rotuloMaterial}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          value={materiais.find((material) => material.id === form.materialId) || null}
          onChange={(event, value) => selecionarCimento(value)}
          renderInput={(params) => <TextField {...params} label="Material / Cimento" />}
          sx={{ flex: 1 }}
        />
      </Stack>
      <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
        <TextField label="Empresa / Contratante" value={form.cliente} InputProps={{ readOnly: true }} fullWidth />
        <Autocomplete
          options={obras}
          getOptionLabel={rotuloObra}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          value={obras.find((obra) => obra.id === form.obraId) || null}
          onChange={(event, value) => selecionarObra(value)}
          renderInput={(params) => <TextField {...params} label="Empreendimento" />}
          fullWidth
        />
        <TextField label="Local / Endereço" value={form.endereco} onChange={(event) => atualizarCampo("endereco", event.target.value)} fullWidth />
      </Stack>
      <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
        <TextField type="date" label="Data" InputLabelProps={{ shrink: true }} value={form.data} onChange={(event) => atualizarCampo("data", event.target.value)} fullWidth />
        <TextField label="Operador" value={form.operador} onChange={(event) => atualizarCampo("operador", event.target.value)} fullWidth />
        <TextField label="Umidade do ar (%)" value={form.umidade} onChange={(event) => atualizarCampo("umidade", event.target.value)} fullWidth />
        <TextField label="Temperatura (C)" value={form.temperatura} onChange={(event) => atualizarCampo("temperatura", event.target.value)} fullWidth />
      </Stack>
      <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
        <Autocomplete
          options={materiaisAditivo}
          getOptionLabel={rotuloMaterial}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          value={materiais.find((material) => material.id === form.aditivo1Id) || null}
          onChange={(event, value) => selecionarAditivo("aditivo1", value)}
          renderInput={(params) => <TextField {...params} label="Aditivo 1" />}
          fullWidth
        />
        <Autocomplete
          options={materiaisAditivo}
          getOptionLabel={rotuloMaterial}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          value={materiais.find((material) => material.id === form.aditivo2Id) || null}
          onChange={(event, value) => selecionarAditivo("aditivo2", value)}
          renderInput={(params) => <TextField {...params} label="Aditivo 2" />}
          fullWidth
        />
        <Autocomplete
          options={materiaisAdicao}
          getOptionLabel={rotuloMaterial}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          value={adicaoSelecionada}
          onChange={(event, value) => selecionarAdicao(value)}
          renderInput={(params) => <TextField {...params} label="Adição" />}
          fullWidth
        />
      </Stack>
    </Stack>
  );

  const camposDoEnsaio = (
    <>
      <Tabs value={aba} onChange={(event, value) => setAba(value)} sx={{ mt: 2 }}>
        <Tab label="Consistência" />
        <Tab label="Início e fim de pega" />
      </Tabs>
      {aba === 0 && (
        <Stack spacing={2}>
          <TabelaConsistencia
            form={form}
            atualizarCampo={atualizarCampo}
            atualizarLinha={atualizarLinha}
            adicionarTentativa={adicionarTentativaConsistencia}
          />
          <TextField
            label="Penetração obtida - consistência normal"
            value={formatarMilimetros(form.penetracaoConsistenciaObtida)}
            InputProps={{ readOnly: true }}
            helperText="Tolerância: 6 ± 1 mm. Campo automático pela última penetração preenchida na tabela."
          />
          <TextField label="Observações" value={form.observacoes} onChange={(event) => atualizarCampo("observacoes", event.target.value)} multiline minRows={3} />
        </Stack>
      )}
      {aba === 1 && (
        <Stack spacing={2}>
          <TabelaDosagem form={form} atualizarLinha={atualizarLinha} somenteLeitura />
          <TextField
            label="Horário de início da mistura"
            value={form.horarioInicioMistura}
            onChange={(event) => atualizarCampo("horarioInicioMistura", event.target.value)}
            placeholder=""
            autoComplete="off"
            fullWidth
          />
          <TabelaLeituras titulo="Controle das leituras - Início de pega" lista="leiturasInicio" linhas={form.leiturasInicio} atualizarLinha={atualizarLinha} />
          <TabelaLeituras titulo="Controle das leituras - Fim de pega" lista="leiturasFim" linhas={form.leiturasFim} atualizarLinha={atualizarLinha} />
          <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
            <ResultadoCampos titulo="Resultado do início de pega" resultado={form.resultadoInicio} penetracao={form.penetracaoInicioObtida} tolerancia="6 ± 2 mm" />
            <ResultadoCampos
                titulo="Resultado do fim de pega"
                resultado={form.resultadoFim}
                penetracao={form.penetracaoFimObtida}
                tolerancia="0,5 mm"
              />
          </Stack>
          <TextField label="Observações do resultado" value={form.observacaoResultado} onChange={(event) => atualizarCampo("observacaoResultado", event.target.value)} multiline minRows={2} />
        </Stack>
      )}
    </>
  );

  if (modoPrint && itemPrint) {
    return (
      <RelatorioCimentoPega
        ensaio={itemPrint}
        autoPrint={autoPrint}
        onVoltar={() => {
          setModoPrint(false);
          setAutoPrint(false);
          setItemPrint(null);
        }}
      />
    );
  }

  if (ensaioId) {
    return (
      <>
        <Navbar />
        <Box className="extracao-actions">
          <Box className="extracao-actions-titulos">
            <Typography component="h1">Consistência e início/fim de pega</Typography>
            <Typography component="p">
              {form.codigo || "CE-RE-IP"}&nbsp;&nbsp; Rev.00 - {formatarDataBR(form.data)}
            </Typography>
          </Box>

          <Box className="extracao-actions-botoes">
            {temAlteracoes ? (
              <>
                <Tooltip title="Visualizar relatório">
                  <span>
                    <IconButton color="primary" disabled aria-label="Visualizar relatório">
                      <VisibilityIcon />
                    </IconButton>
                  </span>
                </Tooltip>
                <Tooltip title="Relatório fotográfico">
                  <span>
                    <IconButton color="primary" disabled aria-label="Relatório fotográfico">
                      <PhotoLibraryIcon />
                    </IconButton>
                  </span>
                </Tooltip>
                <Tooltip title="Imprimir relatrio">
                  <span>
                    <IconButton color="primary" disabled aria-label="Imprimir relatório">
                      <PrintIcon />
                    </IconButton>
                  </span>
                </Tooltip>
                <Button variant="outlined" disabled startIcon={<ArrowBackIcon />}>
                  Voltar
                </Button>
                <Button variant="contained" disabled={salvando} onClick={salvarEnsaio} startIcon={<SaveIcon />}>
                  {salvando ? "Salvando..." : "Salvar"}
                </Button>
                <Button data-confirmacao-cancelamento="propria" variant="outlined" disabled={salvando} onClick={solicitarCancelarAlteracoes}>
                  Cancelar alterações
                </Button>
              </>
            ) : (
              <>
                <Tooltip title="Visualizar relatório">
                  <IconButton color="primary" onClick={() => abrirRelatorio(form, false)} aria-label="Visualizar relatório">
                    <VisibilityIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Relatório fotográfico">
                  <IconButton color="primary" onClick={abrirFotos} aria-label="Relatório fotográfico">
                    <PhotoLibraryIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Imprimir relatório">
                  <IconButton color="primary" onClick={() => abrirRelatorio(form, true)} aria-label="Imprimir relatório">
                    <PrintIcon />
                  </IconButton>
                </Tooltip>
                <Button startIcon={<ArrowBackIcon />} onClick={voltarParaLista}>
                  Voltar
                </Button>
              </>
            )}
          </Box>
        </Box>

        <Box className="extracao-page">
          {mensagem && (
            <Alert severity={mensagem.includes("sucesso") ? "success" : "error"} sx={{ mb: 2 }}>
              {mensagem}
            </Alert>
          )}
          <Paper variant="outlined" sx={{ p: 2 }}>
            {camposBasicos}
            {camposDoEnsaio}
          </Paper>
          <Dialog
            open={openFotos}
            onClose={() => !salvandoFotos && setOpenFotos(false)}
            fullWidth
            maxWidth="sm"
            PaperProps={{
              className: "cimento-fotos-dialog",
              sx: { maxWidth: 700 },
            }}
          >
            <DialogTitle>Relatório fotográfico</DialogTitle>
            <DialogContent dividers>
              <Stack spacing={2}>
                {salvandoFotos && (
                  <Box>
                    <LinearProgress variant={progressoFotos ? "determinate" : "indeterminate"} value={progressoFotos} />
                    <Typography variant="caption" color="text.secondary">
                      Salvando imagens{progressoFotos ? ` - ${progressoFotos}%` : "..."}
                    </Typography>
                  </Box>
                )}
                <Box className="fotos-extracao-grid cimento-fotos-grid">
                  {fotosDraft.map((foto, index) => {
                    const temFoto = Boolean(foto.previewUrl || foto.url);

                    return (
                      <Paper className="foto-extracao-card" key={foto.id} variant="outlined">
                        <Box className="foto-extracao-preview">
                          {temFoto ? (
                            <img src={foto.previewUrl || foto.url} alt={foto.legenda || `Foto ${index + 1}`} />
                          ) : (
                            <Box sx={{ textAlign: "center", px: 1 }}>
                              <PhotoLibraryIcon />
                              <Typography variant="caption" display="block">Sem foto selecionada</Typography>
                            </Box>
                          )}
                        </Box>

                        <Button component="label" variant="outlined" disabled={salvandoFotos}>
                          Selecionar imagem
                          <input hidden type="file" accept="image/*" onChange={(event) => selecionarFoto(index, event.target.files?.[0])} />
                        </Button>

                        <TextField
                          fullWidth
                          size="small"
                          label="Legenda"
                          value={foto.legenda || ""}
                          onChange={(event) => setFotosDraft((fotos) => fotos.map((item, itemIndex) => itemIndex === index ? { ...item, legenda: event.target.value } : item))}
                        />

                        <Button color="error" disabled={salvandoFotos} onClick={() => removerFoto(index)}>
                          Remover
                        </Button>
                      </Paper>
                    );
                  })}
                </Box>
                <Button variant="outlined" onClick={adicionarFoto} disabled={salvandoFotos}>+ Adicionar foto</Button>
              </Stack>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenFotos(false)} disabled={salvandoFotos}>Cancelar</Button>
              <Button variant="contained" onClick={salvarFotos} disabled={salvandoFotos}>{salvandoFotos ? "Salvando..." : "Salvar fotos"}</Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={openConfirmarCancelamento}
            onClose={() => setOpenConfirmarCancelamento(false)}
          >
            <DialogTitle>Cancelar alterações</DialogTitle>
            <DialogContent>
              <Typography>
                Ao confirmar você perderá todas as alterações. Deseja continuar?
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenConfirmarCancelamento(false)}>
                Continuar editando
              </Button>
              <Button color="error" variant="contained" onClick={confirmarCancelarAlteracoes}>
                Descartar alterações
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      </>
    );
  }

  return (
    <>
      <Navbar />

      <Box sx={{ p: { xs: 2, md: 4 } }}>
        <Paper className="cabecalho-lista-cadastro" elevation={0}>
        <Typography variant="h6" fontWeight={700}>Consistência e início/fim de pega</Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>Cadastro e impressão dos ensaios de pasta de cimento</Typography>
        <Stack direction={{ xs: "column", md: "row" }} alignItems="stretch" spacing={2} mb={3}>
          {!clienteLogado && (
            <Button variant="contained" onClick={abrirNovoCadastro}>+ Novo Ensaio</Button>
          )}
          <TextField
            size="small"
            label="Pesquisar"
            placeholder="Código, cliente, empreendimento ou materiais"
            value={filtro}
            onChange={(event) => setFiltro(event.target.value)}
            sx={{ flex: 1 }}
          />
          <TextField size="small" label="Qtd" value={listaFiltrada.length} InputProps={{ readOnly: true }} sx={{ width: 110 }} />
        </Stack>
        </Paper>

        <Paper sx={{ borderRadius: "8px", overflow: "auto", border: "1px solid #e2e8f0", boxShadow: "none" }}>
          <Table className="lista-cadastro-padrao" size="small" sx={{ minWidth: 950, tableLayout: "fixed" }}>
            <TableHead sx={{ backgroundColor: "#f8fafc" }}>
              <TableRow>
                <TableCell sx={{ width: 80 }}><strong>Cód.</strong></TableCell>
                <TableCell sx={{ width: 110 }}>Data</TableCell>
                <TableCell sx={{ width: 300 }}>Cliente / Obra</TableCell>
                <TableCell>Materiais</TableCell>
                <TableCell align="right" sx={{ width: 180 }}>Pega do cimento</TableCell>
                <TableCell align="center" sx={{ width: 170 }}>Ações</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {listaFiltrada.map((item) => (
                <TableRow
                  key={item.id}
                  hover
                  onClick={() => {
                    if (!clienteLogado) {
                      history.push(`/app/cimento-consistencia-pega/${item.id}`);
                    }
                  }}
                  sx={{ cursor: clienteLogado ? "default" : "pointer" }}
                >
                  <TableCell sx={{ width: 80 }}>{item.codigo || "-"}</TableCell>
                  <TableCell sx={{ width: 110 }}>
                    <Typography component="span" variant="caption" sx={{ color: "#64748b", fontWeight: 600 }}>
                      {formatarDataBR(item.data)}
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ width: 300, whiteSpace: "normal", wordBreak: "break-word" }}>
                    <Typography component="div" variant="body2" sx={{ color: "#0f2f5f", fontWeight: 700 }}>
                      {item.cliente || "-"}
                    </Typography>
                    <Typography component="div" variant="caption" sx={{ color: "#475569", fontWeight: 600 }}>
                      Obra: {item.obra || "-"}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Stack spacing={0.25}>
                      <Typography component="span" variant="body2" sx={{ color: "#14532d", fontWeight: 700 }}>
                        Cimento: {item.cimento || "-"}
                      </Typography>
                      <Typography component="span" variant="caption" sx={{ color: "#64748b", fontWeight: 600 }}>
                        Aditivo 1: {formatarMaterialComPercentual(item.aditivo1, item.aditivo1Percentual)}
                      </Typography>
                      <Typography component="span" variant="caption" sx={{ color: "#64748b", fontWeight: 600 }}>
                        Aditivo 2: {formatarMaterialComPercentual(item.aditivo2, item.aditivo2Percentual)}
                      </Typography>
                      <Typography component="span" variant="caption" sx={{ color: "#64748b", fontWeight: 600 }}>
                        Adição: {formatarMaterialComPercentual(item.adicao, item.adicaoPercentual)}
                      </Typography>
                    </Stack>
                  </TableCell>
                  <TableCell align="right" sx={{ width: 180 }}>
                    <Stack spacing={0.25} sx={{ alignItems: "flex-end", textAlign: "right" }}>
                      <Typography component="span" variant="body2" sx={{ color: "#0f2f5f", fontWeight: 700 }}>
                        Início de pega: {item.resultadoInicio?.hora || "-"}
                      </Typography>
                      <Typography component="span" variant="caption" sx={{ color: "#64748b", fontWeight: 600 }}>
                        Tempo: {formatarTempoComUnidade(item.resultadoInicio?.tempoHoraMin)}
                      </Typography>
                      <Typography component="span" variant="caption" sx={{ color: "#64748b", fontWeight: 600 }}>
                        Penetração: {formatarMilimetros(item.penetracaoInicioObtida)}
                      </Typography>
                    </Stack>
                  </TableCell>
                  <TableCell align="center" sx={{ width: 170 }} onClick={(event) => event.stopPropagation()}>
                    <Tooltip title="Visualizar">
                      <IconButton size="small" onClick={() => abrirRelatorio(item, false)}>
                        <VisibilityIcon sx={{ color: "primary.main" }} />
                      </IconButton>
                    </Tooltip>
                    {!clienteLogado && (
                      <>
                        <Tooltip title={item.ocultoCliente ? "Mostrar para cliente" : "Ocultar do cliente"}>
                          <IconButton
                            size="small"
                            onClick={() => alternarVisibilidadeCliente(item)}
                          >
                            {item.ocultoCliente ? (
                              <PersonIcon sx={{ color: "primary.main" }} />
                            ) : (
                              <PersonOffIcon sx={{ color: "text.secondary" }} />
                            )}
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Editar cadastro">
                          <IconButton size="small" onClick={() => editarEnsaio(item)}>
                            <EditIcon sx={{ color: "#0288d1" }} />
                          </IconButton>
                        </Tooltip>
                      </>
                    )}
                    <HistoricoCadastro colecao="tblCimentoConsistenciaPega" documentoId={item.id} registro={item} />
                  </TableCell>
                </TableRow>
              ))}

              {loading && <TableRow><TableCell colSpan={6}><Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 1.5, py: 4 }}><CircularProgress /><Typography color="text.secondary">Carregando registros...</Typography></Box></TableCell></TableRow>}
              {!loading && listaFiltrada.length === 0 && (
                <TableRow>
                  <TableCell colSpan={6} align="center">Nenhum ensaio cadastrado.</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Paper>
      </Box>

      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} fullWidth maxWidth="lg">
        <DialogTitle>{modoEdicao ? "Editar Ensaio" : "Novo Ensaio"}</DialogTitle>
        <DialogContent dividers>
          {camposBasicos}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)} disabled={salvando}>Cancelar</Button>
          <Button variant="contained" onClick={salvarEnsaio} disabled={salvando}>
            {salvando
              ? "Salvando..."
              : modoEdicao
                ? "Salvar"
                : "Salvar e abrir"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

function CampoTabela({ value, onChange, enterList, enterRow, enterCol, readOnly = false }) {
  function moverParaCampoDeBaixo(event) {
    if (event.key !== "Enter") return;
    event.preventDefault();

    if (enterList !== undefined && enterRow !== undefined && enterCol !== undefined) {
      const seletor = `[data-enter-list="${enterList}"][data-enter-row="${Number(enterRow) + 1}"][data-enter-col="${enterCol}"] input`;
      const proximoCampo = document.querySelector(seletor);
      if (proximoCampo) {
        proximoCampo.focus();
        proximoCampo.select?.();
        return;
      }
    }

    const campos = Array.from(document.querySelectorAll("input[data-campo-editavel='true'], textarea[data-campo-editavel='true']"));
    const atual = campos.indexOf(event.currentTarget);
    if (atual >= 0 && campos[atual + 1]) {
      campos[atual + 1].focus();
      campos[atual + 1].select?.();
    }
  }

  return (
    <TextField
      variant="outlined"
      size="small"
      value={value || ""}
      onChange={(event) => onChange(event.target.value)}
      onKeyDown={moverParaCampoDeBaixo}
      autoComplete="off"
      placeholder=""
      InputProps={{ readOnly }}
      inputProps={{
        "data-campo-editavel": readOnly ? "false" : "true",
        style: { textAlign: "center" },
      }}
      data-enter-list={enterList}
      data-enter-row={enterRow}
      data-enter-col={enterCol}
      fullWidth
      sx={{
        "& .MuiOutlinedInput-root": {
          backgroundColor: readOnly ? "#f8fafc" : "#fff",
          borderRadius: "4px",
          minHeight: 34,
        },
        "& .MuiOutlinedInput-input": {
          fontSize: 14,
          padding: "7px 6px",
        },
      }}
    />
  );
}

function TabelaConsistencia({ form, atualizarCampo, atualizarLinha, adicionarTentativa }) {
  return (
    <Paper variant="outlined" sx={{ overflow: "hidden", width: "100%", maxWidth: 1040, mx: "auto" }}>
      <Typography fontWeight={700} textAlign="center" sx={{ p: 1, background: "#d9ead3" }}>
        Determinação da consistência normal
      </Typography>
      <Box sx={{ px: 2, py: 1.5, background: "#fff" }}>
        <Box
          sx={{
            display: "grid",
            gap: 1,
            gridTemplateColumns: {
              xs: "1fr",
              md: "130px 90px minmax(120px, 1fr) minmax(130px, 1fr) minmax(120px, 1fr) minmax(130px, 1fr)",
            },
            alignItems: "center",
          }}
        >
          <Typography fontWeight={700}>Massa do cimento</Typography>
          <Box sx={{ border: "1px solid #cfd7e3", borderRadius: "4px", minWidth: 88, px: 1.5, py: 0.75, textAlign: "center", backgroundColor: "#fff", fontWeight: 700 }}>500 g</Box>
          <TextField size="small" label="Aditivo 1 (%)" value={form.aditivo1Percentual || ""} onChange={(event) => atualizarCampo("aditivo1Percentual", event.target.value)} autoComplete="off" placeholder="" fullWidth />
          <TextField size="small" label="Aditivo 1 qtd. (g)" value={form.aditivo1Quantidade || ""} InputProps={{ readOnly: true }} fullWidth />
          <TextField size="small" label="Aditivo 2 (%)" value={form.aditivo2Percentual || ""} onChange={(event) => atualizarCampo("aditivo2Percentual", event.target.value)} autoComplete="off" placeholder="" fullWidth />
          <TextField size="small" label="Aditivo 2 qtd. (g)" value={form.aditivo2Quantidade || ""} InputProps={{ readOnly: true }} fullWidth />
        </Box>

        <Box
          sx={{
            display: "grid",
            gap: 1,
            gridTemplateColumns: { xs: "1fr", md: "minmax(140px, 200px) minmax(140px, 200px) auto" },
            justifyContent: { xs: "stretch", md: "end" },
            alignItems: "center",
            mt: 1,
          }}
        >
          <TextField size="small" label="Adição (%)" value={form.adicaoPercentual || ""} onChange={(event) => atualizarCampo("adicaoPercentual", event.target.value)} autoComplete="off" placeholder="" fullWidth />
          <TextField size="small" label="Adição qtd. (g)" value={form.adicaoQuantidade || ""} InputProps={{ readOnly: true }} fullWidth />
          <Button variant="outlined" size="small" startIcon={<AddIcon />} onClick={adicionarTentativa} sx={{ minHeight: 40, px: 2, justifySelf: { xs: "stretch", md: "end" } }}>
            Adicionar tentativa
          </Button>
        </Box>
      </Box>
      <Box sx={{ overflow: "auto" }}>
      <Table size="small" className="tabela-cimento-form tabela-consistencia-detalhes" sx={{ width: "100%", minWidth: 760 }}>
        <TableHead>
          <TableRow>
            <TableCell>Tentativa</TableCell>
            <TableCell>Água Quant.</TableCell>
            <TableCell>Água (%)</TableCell>
            <TableCell>Penetração (mm)<br /><small>Consistência normal: 6 ± 1</small></TableCell>
            <TableCell>Situação</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {form.consistencia.map((linha, index) => (
            <TableRow key={linha.tentativa}>
              <TableCell align="center">{linha.tentativa}</TableCell>
              <TableCell><CampoTabela enterList="consistencia" enterRow={index} enterCol="aguaQuantidade" value={linha.aguaQuantidade} onChange={(valor) => atualizarLinha("consistencia", index, "aguaQuantidade", valor)} /></TableCell>
              <TableCell><CampoTabela enterList="consistencia" enterRow={index} enterCol="aguaPercentual" value={linha.aguaPercentual} onChange={(valor) => atualizarLinha("consistencia", index, "aguaPercentual", valor)} /></TableCell>
              <TableCell><CampoTabela enterList="consistencia" enterRow={index} enterCol="penetracao" value={linha.penetracao} onChange={(valor) => atualizarLinha("consistencia", index, "penetracao", valor)} /></TableCell>
              <TableCell><CampoTabela enterList="consistencia" enterRow={index} enterCol="situacao" value={linha.situacao} onChange={(valor) => atualizarLinha("consistencia", index, "situacao", valor)} /></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      </Box>
    </Paper>
  );
}

function TabelaDosagem({ form, atualizarLinha, somenteLeitura = false }) {
  return (
    <Paper variant="outlined" sx={{ overflow: "auto" }}>
      <Typography fontWeight={700} textAlign="center" sx={{ p: 1, background: "#d9ead3" }}>
        Dosagem definida para o ensaio de pega
      </Typography>
      <Table size="small" className="tabela-cimento-form">
        <TableHead>
          <TableRow>
            <TableCell>Material</TableCell>
            <TableCell>Descrição</TableCell>
            <TableCell>Massa</TableCell>
            <TableCell>Percentual (%)</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {form.dosagem.map((linha, index) => (
            <TableRow key={linha.material}>
              <TableCell>{linha.material}</TableCell>
              <TableCell>{somenteLeitura ? linha.descricao || "-" : <CampoTabela value={linha.descricao} onChange={(valor) => atualizarLinha("dosagem", index, "descricao", valor)} />}</TableCell>
              <TableCell>{somenteLeitura ? formatarGramas(linha.massa) : <CampoTabela value={linha.massa} onChange={(valor) => atualizarLinha("dosagem", index, "massa", valor)} />}</TableCell>
              <TableCell>{somenteLeitura ? formatarPercentual(linha.percentual) : <CampoTabela value={linha.percentual} onChange={(valor) => atualizarLinha("dosagem", index, "percentual", valor)} />}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
}

function TabelaLeituras({ titulo, lista, linhas, atualizarLinha }) {
  return (
    <Paper variant="outlined" sx={{ overflow: "auto" }}>
      <Typography fontWeight={700} textAlign="center" sx={{ p: 1, background: "#d9ead3" }}>
        {titulo}
      </Typography>
      <Table size="small" className="tabela-cimento-form">
        <TableHead>
          <TableRow>
            <TableCell>Leitura No</TableCell>
            <TableCell>Hora da leitura</TableCell>
            <TableCell>
  Penetração (mm)
  <br />
  <small>
    {lista === "leiturasInicio"
      ? "Início de pega: 6 ± 2 mm"
      : "Fim de pega: 0,5 mm"}
  </small>
</TableCell>
            <TableCell>Observações</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {linhas.map((linha, index) => (
            <TableRow key={linha.leitura}>
              <TableCell align="center">{linha.leitura}</TableCell>
              <TableCell><CampoTabela enterList={lista} enterRow={index} enterCol="hora" value={linha.hora} onChange={(valor) => atualizarLinha(lista, index, "hora", valor)} /></TableCell>
              <TableCell><CampoTabela enterList={lista} enterRow={index} enterCol="penetracao" value={linha.penetracao} onChange={(valor) => atualizarLinha(lista, index, "penetracao", valor)} /></TableCell>
              <TableCell><CampoTabela enterList={lista} enterRow={index} enterCol="observacoes" value={linha.observacoes} onChange={(valor) => atualizarLinha(lista, index, "observacoes", valor)} /></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
}

function ResultadoCampos({ titulo, resultado, penetracao, tolerancia }) {
  return (
    <Paper variant="outlined" sx={{ p: 2, flex: 1 }}>
      <Typography fontWeight={700} mb={1}>{titulo}</Typography>
      <Stack spacing={1}>
        <TextField size="small" label="Hora" value={resultado.hora || ""} InputProps={{ readOnly: true }} />
        <TextField size="small" label="Tempo decorrido" value={formatarTempoComUnidade(resultado.tempoHoraMin)} InputProps={{ readOnly: true }} />
        <TextField size="small" label={`Penetração obtida (${tolerancia})`} value={formatarMilimetros(penetracao)} InputProps={{ readOnly: true }} />
      </Stack>
    </Paper>
  );
}

function valor(valorCampo) {
  return valorCampo || "";
}

function RelatorioCimentoPega({ ensaio, autoPrint, onVoltar }) {
  useNomeArquivoPdf(ensaio?.codigo);
  useEffect(() => {
    if (!autoPrint) return undefined;
    const frame = window.requestAnimationFrame(() => window.print());
    return () => window.cancelAnimationFrame(frame);
  }, [autoPrint]);

  return (
    <div className="relatorio-cimento-pega-print">
      <div className="acoes-print no-print">
        <button onClick={onVoltar}>Voltar</button>
        <button onClick={() => window.print()}>Imprimir</button>
      </div>

      <RelatorioInicioPegaPrint ensaio={ensaio} />
    </div>
  );
}

function CabecalhoRelatorio({ titulo, codigo }) {
  return (
    <table className="cimento-print-tabela cabecalho-cimento">
      <tbody>
        <tr>
          <td rowSpan={3} className="logo-cell">
            <LogoRelatorio alt="Logo"  />
          </td>
          <td rowSpan={3} className="titulo-cabecalho">
            <div>SISTEMA DE GESTAO DA QUALIDADE</div>
            <div>{titulo}</div>
          </td>
          <td>{codigo}</td>
        </tr>
        <tr><td>Revisao 00</td></tr>
        <tr><td>16/06/2026</td></tr>
      </tbody>
    </table>
  );
}

function DadosClientePrint({ ensaio }) {
  return (
    <div className="dados-cliente-cimento">
      <div><strong>EMPRESA/CONTRATANTE:</strong> {valor(ensaio.cliente)}</div>
      <div><strong>EMPREENDIMENTO:</strong> {valor(ensaio.obra)}</div>
      <div><strong>LOCAL:</strong> {valor(ensaio.endereco)}</div>
    </div>
  );
}

function DadosGeraisPrint({ ensaio, mostrarMateriais = true }) {
  return (
    <>
      <div className="faixa-verde">DADOS GERAIS</div>
      <table className="cimento-print-tabela dados-gerais-cimento">
        <tbody>
          <tr>
            <td><small>Data</small><br />{formatarDataBR(ensaio.data)}</td>
            <td><small>Operador</small><br />{valor(ensaio.operador)}</td>
            <td><small>Hora início</small><br />{valor(ensaio.horarioInicioMistura)}</td>
            <td><small>Temperatura (C)</small><br />{valor(ensaio.temperatura)}</td>
          </tr>
          {mostrarMateriais && (
            <>
              <tr><td colSpan={4}><small>Cimento</small><br />{valor(ensaio.cimento)}</td></tr>
              <tr>
                <td colSpan={2}><small>Aditivo 1</small><br />{valor(ensaio.aditivo1)}</td>
                <td colSpan={2}><small>Aditivo 2</small><br />{valor(ensaio.aditivo2)}</td>
              </tr>
              {ensaio.adicao && (
                <tr><td colSpan={4}><small>Adição</small><br />{valor(ensaio.adicao)}</td></tr>
              )}
            </>
          )}
        </tbody>
      </table>
    </>
  );
}

function FolhaConsistencia({ ensaio }) {
  return (
    <section className="pagina-cimento">
      <CabecalhoRelatorio titulo="Ensaio de consistência pasta de cimento" codigo="RQ 2.2.19 A" />
      <DadosClientePrint ensaio={ensaio} />
      <DadosGeraisPrint ensaio={ensaio} />

      <div className="faixa-verde">DETERMINACAO DA CONSISTENCIA NORMAL</div>
      <div className="massa-cimento-print">
        Massa do cimento: <strong>500 g</strong> &nbsp;&nbsp;|&nbsp;&nbsp;
        Aditivo 1: <strong>{valor(ensaio.aditivo1Quantidade)} g</strong> ({valor(ensaio.aditivo1Percentual)}%) &nbsp;&nbsp;|&nbsp;&nbsp;
        Aditivo 2: <strong>{valor(ensaio.aditivo2Quantidade)} g</strong> ({valor(ensaio.aditivo2Percentual)}%)
      </div>
      <table className="cimento-print-tabela tabela-consistencia-print">
        <thead>
          <tr>
            <th>Tentativa</th>
            <th>AGUA QUANT.</th>
            <th>AGUA %</th>
            <th>Penetração (mm)<br />6 ± 1</th>
            <th>Situacao</th>
          </tr>
        </thead>
        <tbody>
          {(ensaio.consistencia || tentativasConsistencia).map((linha) => (
            <tr key={linha.tentativa}>
              <td>{linha.tentativa}</td>
              <td>{valor(linha.aguaQuantidade)}</td>
              <td>{valor(linha.aguaPercentual)}</td>
              <td>{formatarMilimetros(linha.penetracao)}</td>
              <td>{valor(linha.situacao)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <TabelaDosagemPrint ensaio={ensaio} />
      <div className="penetracao-print"><strong>Penetração obtida - consistência normal:</strong> {formatarMilimetros(ensaio.penetracaoConsistenciaObtida || ensaio.penetracaoObtida)} &nbsp; <strong>Tolerância:</strong> 6 ± 1 mm</div>
      <div className="observacoes-print"><strong>OBSERVAÇÕES:</strong><br />{valor(ensaio.observacoes)}</div>
    </section>
  );
}

function TabelaDosagemPrint({ ensaio }) {
  const dosagem = (ensaio.dosagem || dosagemVazia).filter((linha) =>
    linha.material !== "ADICAO" || String(linha.descricao || "").trim()
  );

  return (
    <>
      <div className="faixa-verde">DOSAGEM DEFINIDA PARA O ENSAIO DE PEGA</div>
      <table className="cimento-print-tabela tabela-dosagem-print">
        <thead>
          <tr><th colSpan={2}>PARÂMETRO</th><th>MASSA</th><th>Percentual (%)</th></tr>
          <tr><th>MATERIAL</th><th>DESCRIÇÃO</th><th></th><th></th></tr>
        </thead>
        <tbody>
          {dosagem.map((linha) => (
            <tr key={linha.material}>
              <td>{linha.material}</td>
              <td>{valor(linha.descricao)}</td>
              <td>{formatarGramas(linha.massa)}</td>
              <td>{formatarPercentual(linha.percentual)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}

function FolhaPega({ ensaio }) {
  return (
    <section className="pagina-cimento">
      <CabecalhoRelatorio titulo="Ensaio de pega do cimento" codigo="RQ 2.2.19 B" />
      <DadosClientePrint ensaio={ensaio} />
      <DadosGeraisPrint ensaio={ensaio} mostrarMateriais={false} />
      <TabelaDosagemPrint ensaio={ensaio} />

      <table className="cimento-print-tabela linhas-info-pega">
        <tbody>
          <tr><td>Horário de início da mistura</td><td>{valor(ensaio.horarioInicioMistura)}</td></tr>
          <tr><td>Penetração obtida - início de pega</td><td>{formatarMilimetros(ensaio.penetracaoInicioObtida)} &nbsp; | &nbsp; Tolerância: 6 ± 2 mm</td></tr>
          <tr>
  <td>Penetração obtida - fim de pega</td>
  <td>
    {formatarMilimetros(ensaio.penetracaoFimObtida)}
    &nbsp; | &nbsp;
    Critério: 0,5 mm
  </td>
</tr>
        </tbody>
      </table>

      <TabelaLeiturasPrint titulo="CONTROLE DAS LEITURAS - INÍCIO DE PEGA" linhas={ensaio.leiturasInicio || leiturasInicio} agulha />
      <TabelaLeiturasPrint titulo="CONTROLE DAS LEITURAS - FIM DE PEGA" linhas={ensaio.leiturasFim || leiturasFim} />

      <table className="cimento-print-tabela resultados-pega-print">
        <thead>
          <tr>
            <th colSpan={2}>RESULTADO DO INÍCIO DE PEGA</th>
            <th colSpan={2}>RESULTADO DO FIM DE PEGA</th>
          </tr>
          <tr><td>Item</td><td>Resultado</td><td>Item</td><td>Resultado</td></tr>
        </thead>
        <tbody>
          <tr><td>Hora do início de pega</td><td>{valor(ensaio.resultadoInicio?.hora)}</td><td>Hora do fim de pega</td><td>{valor(ensaio.resultadoFim?.hora)}</td></tr>
          <tr><td>Tempo decorrido</td><td>{formatarTempoComUnidade(ensaio.resultadoInicio?.tempoHoraMin)}</td><td>Tempo decorrido</td><td>{formatarTempoComUnidade(ensaio.resultadoFim?.tempoHoraMin)}</td></tr>
          <tr><td>Penetração obtida</td><td>{formatarMilimetros(ensaio.penetracaoInicioObtida)}</td><td>Penetração obtida</td><td>{formatarMilimetros(ensaio.penetracaoFimObtida)}</td></tr>
        </tbody>
      </table>
    </section>
  );
}

function TabelaLeiturasPrint({ titulo, linhas, agulha = false }) {
  return (
    <>
      <div className="faixa-verde">{titulo}</div>
      <table className="cimento-print-tabela tabela-leituras-print">
        <thead>
          <tr>
            <th>Leitura No</th>
            <th>Hora da Leitura</th>
            <th>{agulha ? "Penetração da agulha (mm)" : "Penetração (mm)"}</th>
            <th>Observações</th>
          </tr>
        </thead>
        <tbody>
          {linhas.map((linha) => (
            <tr key={linha.leitura}>
              <td>{linha.leitura}</td>
              <td>{valor(linha.hora)}</td>
              <td>{formatarMilimetros(linha.penetracao)}</td>
              <td>{valor(linha.observacoes)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}

export default CadastroCimentoPega;
